function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import GroupItem from "./group-item";
var visibleGroupItems = 4;
var GroupItems = function GroupItems(_ref) {
  var groupIndex = _ref.groupIndex,
    items = _ref.items,
    language = _ref.language,
    isMobile = _ref.isMobile,
    showMoreLabel = _ref.showMoreLabel,
    homePageLabel = _ref.homePageLabel,
    showGroupItems = _ref.showGroupItems;
  var _useState = useState(items.length > visibleGroupItems && items.length - visibleGroupItems > 1),
    _useState2 = _slicedToArray(_useState, 2),
    hideitems = _useState2[0],
    setHideItems = _useState2[1];
  var handleShowMoreItems = function handleShowMoreItems(e) {
    e.preventDefault();
    setHideItems(false);
  };
  var accessibilityAttr = isMobile && items.length > 1 ? {
    role: "region",
    "aria-labelledby": "footer-group-header-".concat(groupIndex + 1),
    hidden: !showGroupItems
  } : {};
  return /*#__PURE__*/React.createElement("ul", _extends({
    id: "footer-group-items-".concat(groupIndex + 1),
    className: "footer__group__items"
  }, accessibilityAttr), items.map(function (item, itemIndex) {
    return /*#__PURE__*/React.createElement(GroupItem, {
      key: "group-".concat(groupIndex, "-item-").concat(itemIndex),
      index: itemIndex,
      item: item,
      language: language,
      isMobile: isMobile,
      homePageLabel: homePageLabel,
      hidden: itemIndex >= visibleGroupItems && items.length - visibleGroupItems > 1 && hideitems
    });
  }), hideitems && !isMobile && /*#__PURE__*/React.createElement("button", {
    className: "footer__group__show-more-btn ".concat(!hideitems ? "hidden" : ""),
    onClick: function onClick(e) {
      return handleShowMoreItems(e);
    },
    dangerouslySetInnerHTML: {
      __html: showMoreLabel
    }
  }));
};
export default GroupItems;